import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, toDisplayString as _toDisplayString, withModifiers as _withModifiers, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "modal-mask"
}
const _hoisted_2 = { class: "modal-wrapper" }
const _hoisted_3 = { class: "modal-dialog" }
const _hoisted_4 = { class: "modal-content" }
const _hoisted_5 = { class: "modal-body" }
const _hoisted_6 = { class: "form-group" }
const _hoisted_7 = { class: "text-danger" }
const _hoisted_8 = { class: "modal-footer" }
const _hoisted_9 = ["disabled"]
const _hoisted_10 = { key: 0 }
const _hoisted_11 = { key: 1 }

import { computed, toRef } from 'vue'

    import type { EvalModelEditorViewModel } from '@Evaluation/EvaluationModels/Components/EvalModelEditor'

    // ---------------- props / emits ----------------

    
export default /*@__PURE__*/_defineComponent({
  __name: 'EvalModelEditor',
  props: {
    viewModel: {}
  },
  emits: ["update-evalmodel"],
  setup(__props: any, { emit: __emit }) {

    const props = __props

    const emit = __emit

    // ---------------- shortcuts ----------------

    const vm = toRef(props, 'viewModel')

    // ---------------- derived ----------------

    const opened = computed(() => vm.value?.opened ?? false)

    const operationInProgress = computed(() => vm.value.operationInProgress)

    const goalError = computed<string | null>(() =>
        vm.value.errors.length ? vm.value.errors[0].Error : null
    )

    // writable computed (mirrors getter/setter)
    const goalName = computed<string | null>({
        get: () => vm.value.name,
        set: val => { vm.value.name = val }
    })

    // ---------------- actions ----------------

    function handleFormSubmit()
    {
        vm.value.operationInProgress = true
        vm.value.clearValidationErrors()

        emit('update-evalmodel', vm.value.id, goalName.value)
    }

    function close()
    {
        vm.value.close()
    }

return (_ctx: any,_cache: any) => {
  return (opened.value)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("div", { class: "modal-header" }, [
                _cache[1] || (_cache[1] = _createElementVNode("h5", { class: "modal-title" }, "Edit goal", -1 /* CACHED */)),
                _createElementVNode("button", {
                  type: "button",
                  class: "close",
                  onClick: close
                }, "×")
              ]),
              _createElementVNode("div", _hoisted_5, [
                _createElementVNode("form", {
                  id: "evalmodel-editor-form",
                  onSubmit: _withModifiers(handleFormSubmit, ["prevent"])
                }, [
                  _createElementVNode("div", _hoisted_6, [
                    _cache[2] || (_cache[2] = _createElementVNode("label", null, "Goal name:", -1 /* CACHED */)),
                    _withDirectives(_createElementVNode("input", {
                      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((goalName).value = $event)),
                      type: "text",
                      class: "form-control",
                      required: "",
                      minlength: "2",
                      maxlength: "100"
                    }, null, 512 /* NEED_PATCH */), [
                      [
                        _vModelText,
                        goalName.value,
                        void 0,
                        { trim: true }
                      ]
                    ]),
                    _createElementVNode("small", _hoisted_7, _toDisplayString(goalError.value), 1 /* TEXT */)
                  ])
                ], 32 /* NEED_HYDRATION */)
              ]),
              _createElementVNode("div", _hoisted_8, [
                _createElementVNode("button", {
                  type: "button",
                  onClick: close,
                  class: "btn btn-outline-secondary"
                }, "Cancel"),
                _createElementVNode("button", {
                  type: "submit",
                  form: "evalmodel-editor-form",
                  disabled: operationInProgress.value,
                  class: "btn btn-primary"
                }, [
                  (operationInProgress.value)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_10, [...(_cache[3] || (_cache[3] = [
                        _createElementVNode("i", { class: "fa fa-spinner fa-spin" }, null, -1 /* CACHED */),
                        _createTextVNode(" Please wait...", -1 /* CACHED */)
                      ]))]))
                    : _createCommentVNode("v-if", true),
                  (!operationInProgress.value)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_11, "Update"))
                    : _createCommentVNode("v-if", true)
                ], 8 /* PROPS */, _hoisted_9)
              ])
            ])
          ])
        ])
      ]))
    : _createCommentVNode("v-if", true)
}
}

})